export class FidelidadeEmail {
  id: number;
  idClassificacao: number;
  descricaoClassificacao: string;
  idTemplateEmail: number;
  descricaoTemplateEmail: string;
  tipo: number;
  tipoDescricao: string;
}
